var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialog360(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 109,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3DCE6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.8 47.8a3.7 3.7 0 003.6 3.6h8.3a4.6 4.6 0 10-.1-9.1 4.6 4.6 0 10-9 1.9 3.7 3.7 0 00-2.8 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E0E6ED",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M87.8 44h-1.6A9.7 9.7 0 1077 56.3h10.8a6 6 0 000-12.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFE",
    d: "M69 35c0 10-8.3 18-18.5 18S32 45 32 35s8.3-18 18.5-18 18.4 8 18.4 18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4369",
    d: "M65.8 35c0 8.3-6.8 15-15.3 15S35 43.3 35 35s7-15 15.5-15 15.3 6.7 15.3 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.3 40.2c-2 0-3.6-1.3-4-3.1v-.6h1.5v.4a2.4 2.4 0 002.5 1.9c1.4 0 2.4-1 2.4-2.4s-1-2.4-2.4-2.4h-.6l-1.6.3 1.1-1.1 1.3-1.3.6-.5h-4v-1.5h7.5l-2.9 2.9c1.5.5 2.5 1.9 2.5 3.6 0 2.2-1.7 3.8-4 3.8zm8.4-6.3c-1.4 0-2.5 1-2.5 2.4s1 2.4 2.5 2.4c1.3 0 2.4-1 2.4-2.4 0-1.3-1-2.4-2.4-2.4zm0 6.3c-2.3 0-4-1.7-4-3.9 0-.8.3-1.6.8-2.3l3.2-4.1h1.8l-2 2.6h.2c2.2 0 3.9 1.6 3.9 3.8s-1.7 3.9-4 3.9zm9.4-9c-2 0-3.6 1.6-3.6 3.7s1.6 3.9 3.6 3.9 3.7-1.8 3.7-3.9c0-2-1.6-3.8-3.7-3.8zm0 9A5.2 5.2 0 0154 35c0-2.9 2.3-5.2 5.1-5.2 3 0 5.2 2.3 5.2 5.2 0 3-2.3 5.3-5.2 5.3z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFE",
    stroke: "#D3DCE6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M58.3 21.3a5.7 5.7 0 005.6 5.6h12.8a7 7 0 10-.2-14.1 7 7 0 10-13.8 3 5.7 5.7 0 00-4.4 5.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: 100.9,
    height: 100,
    x: 0,
    y: 9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow",
    result: "effect4_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect4_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog360);
export default __webpack_public_path__ + "static/media/Dialog360.73536188d8aade4a4c4ffb2da588887f.svg";
export { ForwardRef as ReactComponent };